import * as actionTypes from "../actions/actionTypes";
import type { AuthState } from "../../types/auth";
import type { AuthAction } from "../actions/auth";
import type { UnknownAction } from "redux";

const initialState: AuthState = {
  authToken: null,
  id: null,
  name: "",
  email: "",
  userType: 0,
  quickbooksConnected: false,
  tenant: null,
  error: null,
  loading: false,
};

const reducer = (state: AuthState = initialState, action: UnknownAction): AuthState => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return { ...state, error: null, loading: true };
    case actionTypes.AUTH_SUCCESS:
      const success = action as Extract<AuthAction, { type: typeof actionTypes.AUTH_SUCCESS }>;
      return {
        ...state,
        authToken: success.authToken,
        error: null,
        loading: false,
        name: success.name,
        email: success.email,
        id: success.id,
        userType: success.userType,
        quickbooksConnected: success.quickbooksConnected,
        tenant: success.tenant,
      };
    case actionTypes.AUTH_FAIL: {
      const failure = action as Extract<AuthAction, { type: typeof actionTypes.AUTH_FAIL }>;
      const errorData = failure.error?.data;
      return {
        ...state,
        error: {
          title: typeof errorData?.title === "string" ? errorData.title : "",
          subtitle:
            typeof errorData?.subtitle === "string"
              ? errorData.subtitle
              : "We could not complete your request, please try again.",
        },
        loading: false,
      };
    }
    case actionTypes.AUTH_LOGOUT:
      return { ...initialState };
    case actionTypes.UPDATE_ACCOUNT_SUCCESS:
      const account = action as Extract<
        AuthAction,
        { type: typeof actionTypes.UPDATE_ACCOUNT_SUCCESS }
      >;
      return { ...state, name: account.name, email: account.email, loading: false };
    case actionTypes.UPDATE_TENANT_SUCCESS:
      const company = action as Extract<
        AuthAction,
        { type: typeof actionTypes.UPDATE_TENANT_SUCCESS }
      >;
      return { ...state, tenant: company.tenant };
    default:
      return state;
  }
};

export default reducer;
